import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { TextField, Button, Box, Typography, Container, FormControlLabel, Checkbox } from "@mui/material";
import { AppBar, Toolbar, Avatar } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";

const RegisterForm = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [acceptPolicies, setAcceptPolicies] = useState(false);
  const [users, setUsers] = useState([]);
  const baseUrl = process.env.REACT_APP_APP_URL;

  useEffect(() => {
    axios
      .get(`${baseUrl}/api/users`)
      .then((res) => {
        setUsers(res.data);
        console.log("Users fetched:", res.data);
      })
      .catch((err) => {
        console.log("Error fetching users:", err);
      });
  }, [baseUrl]);

  const isEmailTaken = (email) => {
    const exists = users.some((user) => user.email === email);
    console.log("Email exists:", exists);
    return exists;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    

    if (password !== password2) {
      toast.warn("Les mots de passe ne correspondent pas", {
        position: "top-right",
        autoClose: 3000,
      });
    } else if (isEmailTaken(email)) {
      toast.warn("L'email existe déjà", {
        position: "top-right",
        autoClose: 3000,
      });
    } else {
      const userData = {
        name: name,
        email: email,
        password: password,
        password_confirmation: password2,
      };

      axios
        .post(`${baseUrl}/api/register`, userData)
        .then((res) => {
          console.log("Registration successful:", res.data);
          toast.success("Compte créé avec succès !", {
            position: "top-right",
            autoClose: 3000,
          });
          navigate("/login");
        })
        .catch((err) => {
          console.log("Registration error:", err);
          toast.error("Erreur lors de l'inscription", {
            position: "top-right",
            autoClose: 3000,
          });
        });
    }
  };

  return (
    <div>
      <ToastContainer />
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar
            alt="Logo"
            src="../assets/cej.png"
            sx={{ width: 40, height: 40, marginRight: "0.5rem" }}
          />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
        </Toolbar>
      </AppBar>

      <Container
        maxWidth="sm"
        sx={{
          marginTop: "100px",
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            marginBottom: "1rem",
            color: "#003366",
          }}
        >
          Créer un compte
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Nom et prénom"
            variant="outlined"
            fullWidth
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            sx={{ marginBottom: "1rem" }}
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            type="email"
            sx={{ marginBottom: "1rem" }}
          />
          <TextField
            label="Password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            type="password"
            sx={{ marginBottom: "1rem" }}
          />
          <TextField
            label="Retapez le mot de passe"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            required
            type="password"
            sx={{ marginBottom: "1rem" }}
          />
         
          <Button
            variant="contained"
            fullWidth
            type="submit"
            sx={{
              backgroundColor: "#003366",
              color: "#fff",
              marginTop: "1rem",
              "&:hover": {
                backgroundColor: "#00509d",
              },
            }}
          >
           S'enregistrer
          </Button>
        </form>
      </Container>
      <Box sx={{ textAlign: "center", marginTop: "1rem" }}>
          <Typography variant="body2">
            Vous avez déja un compte ?
            <Button onClick={() => navigate("/login")} sx={{ textTransform: "none", color: "#003366" }}>
              Connectez-vous
            </Button>
          </Typography>
        </Box>
    </div>
  );
};

export default RegisterForm;
